import { Form } from "react-bootstrap";
import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";
import { addData, getData } from "./utils";

interface IFormSelectProps extends IFormInputDefault{
  options:any[];
}

export default function FormSelect({
  title,
  name,
  state,
  onChange,
  options,
  ...props
}:IFormSelectProps){

  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name;
    props_aux["value"] = state.model?getData(state.model,name):"";
  }

  return (
    <BodyInputFormat props={{...props,title}}>
      <Form.Select size="sm"
        onChange={(event)=>{
          if(state && name){
            let value = event.target.value;

            state.setModel((old:any)=>{
              return addData(old,name,value);
            });
          }
          if(onChange)onChange(event)
        }} 
        {...props}
        {...props_aux}
      >
        {options.map((item, key)=>{
          if(item.options){
            return (
              <optgroup label={item.name} key={key}>
                {item.options.map((item2:any, key2:number)=>{
                  return <option value={item2.value} key={key2}>{item2.name}</option>
                })}
              </optgroup>
            )
          } else {
            return <option value={item.value} key={key}>{item.name}</option>
          }
        })}
      </Form.Select>
    </BodyInputFormat>
  );
}